export class SentryTagKey {
  public static appVersion = "custom.app_version";
  public static correlationId = "custom.correlation_id";
}
